import React from "react";
import "./GetMusicOnVevo.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnVevo = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music video",
    "Select VEVO distribution",
    "Video delivered to VEVO channels",
    "Reach global on YouTube & TV",
    "Track views & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>VEVO Music Video Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music videos to VEVO with FT Tunes. Reach global audiences and monetize your official music videos worldwide."
        />

        <meta
          name="keywords"
          content="VEVO distribution, VEVO music videos, YouTube VEVO channel, music video distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="vevo-page">

        {/* HERO */}
        <section className="vevo-hero">
          <Container>

            <img
              src="/Images/vevo-logo.png"
              alt="VEVO"
              className="vevo-logo"
            />

            <h1>Distribute Your Music Videos on VEVO</h1>

            <p>
              Launch your official artist channel and distribute
              high-quality music videos worldwide through VEVO’s
              premium global network.
            </p>

            <Button
              className="gradient-btn-vevo"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Videos
            </Button>

          </Container>

          <div className="hero-glow-vevo"></div>
        </section>


        {/* SHOWCASE */}
        <section className="vevo-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Millions Through Official VEVO Channels</h2>

                <p>
                  VEVO powers some of the biggest music video channels
                  globally. Showcase your visuals professionally and
                  grow your fanbase across YouTube, smart TVs,
                  and streaming platforms.
                </p>

                <Button
                  className="outline-btn-vevo"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Video
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-vevo.png"
                  alt="Get Music On VEVO"
                  className="vevo-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="vevo-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-vevo">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="vevo-benefits">
          <Container>

            <h2 className="section-title">
              Why Release Videos on VEVO
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-vevo">
                  <h5>Official Artist Channel</h5>
                  <p>Build verified VEVO presence.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-vevo">
                  <h5>Global Exposure</h5>
                  <p>Reach worldwide music audiences.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-vevo">
                  <h5>High-Quality Video Delivery</h5>
                  <p>Premium HD & TV distribution.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-vevo">
                  <h5>Revenue Monetization</h5>
                  <p>Earn from official video streams.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="vevo-cta">
          <Container>

            <h2>Launch Your Official VEVO Channel Today</h2>

            <Button
              className="gradient-btn-vevo big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnVevo;